import {
  RESET_ZOOM_CREDENTIALS,
  RESET_ZOOM_CREDENTIALS_SUCCESS,
  RESET_ZOOM_CREDENTIALS_FAIL,
  GET_ZOOM_AUTH_URL,
  GET_ZOOM_AUTH_URL_SUCCESS,
  GET_ZOOM_AUTH_URL_FAIL
} from "./actionTypes"

export const resetZoomCredentails = code => ({
  type: RESET_ZOOM_CREDENTIALS,
  payload: code,
})

export const resetZoomCredentailSuccess = response => ({
  type: RESET_ZOOM_CREDENTIALS_SUCCESS,
  payload: response,
})

export const resetZoomCredentailFail = error => ({
  type: RESET_ZOOM_CREDENTIALS_FAIL,
  payload: error,
})

export const getZoomAuthURL = () => ({
  type: GET_ZOOM_AUTH_URL,
})

export const getZoomAuthURLSuccess = response => ({
  type: GET_ZOOM_AUTH_URL_SUCCESS,
  payload: response,
})

export const getZoomAuthURLFail = error => ({
  type: GET_ZOOM_AUTH_URL_FAIL,
  payload: error,
})
